module.exports = __webpack_public_path__ + "prod/20260124143402/img/map2d.f2386104.jpg";